export default { outboundTransmission: {} };